/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesPriceListResponseDto } from '../../models/sales-price-list-response-dto';

export interface PriceListsControllerRemove$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the price list to delete.
 */
  id: string;
}

export function priceListsControllerRemove(http: HttpClient, rootUrl: string, params: PriceListsControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListsControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesPriceListResponseDto>;
    })
  );
}

priceListsControllerRemove.PATH = '/o2-sales/price-lists/{tenant}/{id}';
